
  export default {
    mounted() {
      this.el.addEventListener("change", () => {
        const value = this.el.value;
        const link = document.getElementById("theme-css");
        if (link) {
          link.setAttribute("href", "/assets/css/" + value + ".css");
        }
        this.pushEvent("theme-set", { value: value });
      });
    }
  }
